import { NgModule } from '@angular/core';
import { MaterialModule } from './modules/material/material.module';
import { DocumentActivePipe } from './shared/pipes/documents/documentActive.pipe';
import { DocumentTypeFilter } from './shared/pipes/documents/documentTypeFilter.pipe';
import { FilterByPipe } from './shared/pipes/filter-by.pipe';
import { IsActivePipe } from './shared/pipes/is-active.pipe';
import { SortByPipe } from './shared/pipes/sort-by.pipe';
import { ListManagementModalComponent } from './shared/components/list-management-modal/list-management-modal.component';
import { CommonModule, DatePipe, NgForOf, NgIf } from '@angular/common';
import { BillRequestsContentComponent } from './shared/components/bill-requests-content/bill-requests-content.component';
import { BillRequestItemComponent } from './shared/components/bill-request-item/bill-request-item.component';
import { RouterLink } from '@angular/router';
import { QuillModule } from 'ngx-quill';
import { LinkDirective } from './shared/directives/link.directive';
import { TrackingDataModalComponent } from './shared/components/tracking-data-modal/tracking-data-modal.component';
import { ReactiveFormsModule } from '@angular/forms';
import { TruncatePipe } from './shared/pipes/truncate.pipe';
import { BillSearchModalComponent } from './modules/bills/bill-search-modal/bill-search-modal.component';

@NgModule({
    imports: [
        ReactiveFormsModule,
        CommonModule,
        MaterialModule,
        NgIf,
        NgForOf,
        DatePipe,
        RouterLink,
        QuillModule,
    ],
    declarations: [
        FilterByPipe,
        IsActivePipe,
        SortByPipe,
        DocumentActivePipe,
        DocumentTypeFilter,
        ListManagementModalComponent,
        TrackingDataModalComponent,
        BillRequestsContentComponent,
        BillRequestItemComponent,
        LinkDirective,
        TruncatePipe,
        BillSearchModalComponent,
    ],
    exports: [
        FilterByPipe,
        IsActivePipe,
        SortByPipe,
        DocumentActivePipe,
        DocumentTypeFilter,
        MaterialModule,
        ListManagementModalComponent,
        TrackingDataModalComponent,
        BillRequestsContentComponent,
        BillRequestItemComponent,
        QuillModule,
        LinkDirective,
        TruncatePipe,
        BillSearchModalComponent,
    ],
})
export class AppSharedModule {}
